import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-grid",
  "use": "icon-grid-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-grid\"><path d=\"M.637 20.13v-6.65h6.649v6.65zM.637 7.286V.636h6.649v6.65zM13.481 20.13v-6.65h6.649v6.65zM13.481 7.286V.636h6.649v6.65z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol